<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit Session Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Session</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="row mb-4" :form="form">
          <a-form-item label="Start Date" class="col-sm-6">
            <a-date-picker
              v-decorator="[
              'start_date',
              {rules: [{ required: true, message: 'Please input a start date' }],},
              ]"
              :format=dateFormat
            />
          </a-form-item>
          <a-form-item label="End Date" class="col-sm-6">
            <a-date-picker
              v-decorator="[
              'end_date',
              {rules: [{ required: true, message: 'Please input an end date' }],},
              ]"
              :format=dateFormat
            />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import pick from 'lodash/pick'
import moment from 'moment'

export default {
  name: 'EditSession',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      boardId: null,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  mounted: function () {
    this.$eventBus.$on('openSessionEditModal', this.showModal)
  },
  methods: {
    showModal: function(sessionId) {
      this.sessionId = sessionId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/session/' + sessionId).then(({ data }) => {
        const editData = pick({ ...data.data }, ['start_date', 'end_date'])
        editData.start_date = moment(editData.start_date)
        editData.end_date = moment(editData.end_date)
        this.form.setFieldsValue(editData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/session/' + this.sessionId, {
                  start_date: moment(values.start_date).format('YYYY-MM-DD'),
                  end_date: moment(values.end_date).format('YYYY-MM-DD'),
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Board details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
